"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Defined states
 */
const STATE = ['Idle', 'SelectWallet', 'InputAsset', 'EstablishConnection', 'ConnectDevice', 'ConfirmAddress', 'Error', 'Success'];
const MACHINE = {
  Idle: {
    currentState: 'Idle',
    nextState: [{
      step: 'SelectWallet',
      pattern: null
    }]
  },
  SelectWallet: {
    currentState: 'SelectWallet',
    nextState: [{
      step: 'InputAsset',
      pattern: {
        type: 'softwallet',
        wallet: 'isoxys'
      }
    }, {
      step: 'ConnectDevice',
      pattern: {
        type: 'hardwallet'
      }
    }, {
      step: 'EstablishConnection',
      pattern: {
        type: 'hybridwallet'
      }
    }, {
      step: 'Success',
      pattern: {
        type: 'softwallet',
        wallet: 'metamask',
        model: 'metamask'
      }
    }, {
      step: 'Error',
      pattern: {
        wallet: '*',
        type: '*'
      }
    }]
  },
  InputAsset: {
    currentState: 'InputAsset',
    nextState: [{
      step: 'ConfirmAddress',
      pattern: {
        model: 'mnemonic'
      }
    }, {
      step: 'ConfirmAddress',
      pattern: {
        model: 'keystore'
      }
    }, {
      step: 'ConfirmAddress',
      pattern: {
        model: 'private-key'
      }
    }, {
      step: 'Error',
      pattern: {
        model: '*'
      }
    }]
  },
  EstablishConnection: {
    currentState: 'EstablishConnection',
    nextState: [{
      step: 'Success',
      pattern: {
        provider: true
      }
    }, {
      step: 'Error',
      pattern: {
        provider: false
      }
    }]
  },
  ConnectDevice: {
    currentState: 'ConnectDevice',
    nextState: [{
      step: 'ConfirmAddress',
      pattern: {
        wallet: 'ledger',
        model: 'ledger-nano-s'
      }
    }, {
      step: 'ConfirmAddress',
      pattern: {
        wallet: 'trezor',
        model: 'trezor-one'
      }
    }, {
      step: 'Error',
      pattern: {
        model: '*'
      }
    }]
  },
  ConfirmAddress: {
    currentState: 'ConfirmAddress',
    nextState: [{
      step: 'Success',
      pattern: {
        dpath: true
      }
    }, {
      step: 'Error',
      pattern: {
        dpath: false
      }
    }]
  },
  Error: {
    currentState: 'Error',
    nextState: [{
      step: 'Idle',
      pattern: null
    }]
  },
  Success: {
    currentState: 'Success',
    nextState: [{
      step: 'Idle',
      pattern: null
    }]
  }
};
/**
 * Class
 */

const DEFAULT = {
  step: STATE[0],
  type: null,
  // softwallet, hardwallet, hybridwallet
  wallet: null,
  // metamask, isoxys, ledger, trezor, mew
  model: null,
  // mnemonic, keystore, private-key, ledger-nano-s, trezor-one, mew
  dpath: null,
  index: null,
  asset: null
};

class FiniteStateMachine {
  constructor() {
    _defineProperty(this, "reset", () => {
      this.data = DEFAULT;
      this.index = 0;

      for (let i = 0; i < this.history.length; i++) {
        delete this.history[i];
      }

      this.history.length = 0;
      this.history = [this.data];
    });

    _defineProperty(this, "match", (pattern, data) => {
      if (data == null) throw new Error('Finite State Machine was broken');
      if (pattern == null) return true;
      let keys = Object.keys(pattern);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        let key = _keys[_i];

        if (typeof pattern[key] === 'boolean') {
          if (pattern[key] !== '*' && pattern[key] !== Boolean(data[key])) return false;
        } else if (pattern[key] !== '*' && pattern[key] !== data[key]) return false;
      }

      return true;
    });

    _defineProperty(this, "back", () => {
      if (this.index > 0) {
        delete this.history[this.history.length - 1];
        this.history.length = this.index;
        this.index = this.index - 1;
        this.data = this.history[this.index];
      }

      return this.data;
    });

    _defineProperty(this, "next", data => {
      this.data = _objectSpread(_objectSpread({}, this.data), data);
      this.history.push(this.data);
      this.index = this.index + 1;
      let currentState = MACHINE[this.data.step];

      var _iterator = _createForOfIteratorHelper(currentState.nextState),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          let nextState = _step.value;
          let ok = this.match(nextState.pattern, this.data);

          if (ok) {
            this.data.step = nextState.step;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.data;
    });

    this.data = DEFAULT;
    this.index = 0;
    this.history = [this.data];
  }

}

var _default = FiniteStateMachine;
exports.default = _default;